module.exports = __webpack_public_path__ + "img/2014-01_bloomberg_a.cf310e25.png";